import React from "react"
import { Card, CardBody, Row, Col, Badge } from "reactstrap"
import { capitalize } from "lodash"
import moment from "moment-timezone"

const LeadDate = ({ value }) => value && moment(value).isValid()
  ? <time dateTime={value}>{moment(value).tz("Europe/Bucharest").format("DD MMM YYYY, HH:mm:ss")}</time>
  : <span>Not available</span>

export const LeadHeader = ({ lead, actions }) => <Card className="club-profile-hero">
  <CardBody>
    <div className="club-profile-hero-main">
      <div className="lead-heading">
        <div className="club-profile-eyebrow mb-2">Club business lead {lead.leadId != null && `#${lead.leadId}`}</div>
        <h1 className="h3 mb-2">{lead.clubName || "Unnamed club"}</h1>
        <Badge color={lead.status === "closed" ? "secondary" : "warning"}>{capitalize(lead.status) || "Status not specified"}</Badge>
      </div>
      <div className="club-profile-actions">{actions}</div>
    </div>
    <dl className="lead-metadata mb-0">
      <div><dt>Created</dt><dd><LeadDate value={lead.createdAt} /></dd></div>
      <div><dt>Last updated</dt><dd><LeadDate value={lead.updatedAt} /></dd></div>
      <div className="text-muted lead-timezone">Europe/Bucharest</div>
    </dl>
  </CardBody>
</Card>

export const LeadPanels = ({ club, contact }) => <Row className="lead-panels">
  <Col lg={6} className="d-flex"><Card className="club-profile-card w-100"><CardBody>
    <h2 className="h5 mb-4">Club details</h2>{club}
  </CardBody></Card></Col>
  <Col lg={6} className="d-flex"><Card className="club-profile-card w-100"><CardBody>
    <h2 className="h5 mb-4">Contact person</h2>{contact}
  </CardBody></Card></Col>
</Row>

const Detail = ({ label, children }) => <div><dt>{label}</dt><dd>{children}</dd></div>

export default function LeadProfile({ lead, actions }) {
  const address = lead.location?.name || [lead.location?.city, lead.location?.country].filter(Boolean).join(", ")
  const phoneLink = lead.phone?.replace(/[^+\d]/g, "")
  return <>
    <LeadHeader lead={lead} actions={actions} />
    <LeadPanels club={<dl className="lead-details mb-0">
      <Detail label="Location">{address || "Location not specified"}</Detail>
      <Detail label="Sports">{lead.sports?.length ? <div className="lead-sport-badges">
        {lead.sports.map(sport => <Badge key={sport} color="light">{capitalize(sport)}</Badge>)}
      </div> : "Sports not specified"}</Detail>
      <Detail label="Courts">{lead.noCourts ?? "Not specified"}</Detail>
    </dl>} contact={<dl className="lead-details mb-0">
      <Detail label="Name">{[lead.firstName, lead.lastName].filter(Boolean).join(" ") || "Not specified"}</Detail>
      {lead.jobTitle && <Detail label="Job title">{lead.jobTitle}</Detail>}
      <Detail label="Email">{lead.email ? <a href={`mailto:${lead.email}`}>{lead.email}</a> : "Not specified"}</Detail>
      <Detail label="Phone">{lead.phone ? <a href={`tel:${phoneLink}`}>{lead.phone}</a> : "Not specified"}</Detail>
    </dl>} />
  </>
}
